import { render, staticRenderFns } from "./TxProductStats.vue?vue&type=template&id=20bfa749&"
import script from "./TxProductStats.vue?vue&type=script&lang=js&"
export * from "./TxProductStats.vue?vue&type=script&lang=js&"
import style0 from "./TxProductStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports